import { LOGIN_URL } from 'utils'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { sendGTMData } from 'utils/gtm.js'

// componente dummy per redirigere al login esterno

const Login = ({ next = '' }) => {
  const router = useRouter()

  useEffect(() => {
    sendGTMData({
      event: 'GAevent',
      eventID: '25',
      eventCategory: 'registrazione_login_popup',
      eventAction: 'login_ok',
      eventLabel: 'non_valorizzata',
    })

    if (
      next.includes('/registrazione/reset-password') ||
      router.asPath.includes('/registrazione/reset-password')
    ) {
      router.push(`${LOGIN_URL}?next=/area-personale`)
    } else {
      router.push(`${LOGIN_URL}?next=${next || router.asPath}`)
    }
  }, []) // empty dependency array = runs only once on mount

  return null
}

export default Login
